import React, { useState } from "react";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
import contentData from "../content.json";
import ImageModal from "./ImageModal";

const Coaching = () => {
  const coaching = contentData.coaching || {};
  const rankings = coaching.rankings || [];
  const accolades = coaching.accolades || [];
  const [selectedImage, setSelectedImage] = useState(null);

  const pricingModels = coaching.pricing_models || [];

  const galleryImages = [
    { 
      src: "/assets/BH.jpg", 
      alt: "Backhand technique",
      style: {
        objectPosition: "center 30%", // Adjust to show face better
        objectFit: "cover"
      }
    },
    { 
      src: "/assets/Serve.jpg", 
      alt: "Serve technique",
      style: {
        objectPosition: "center center", // Show full body
        objectFit: "cover"
      }
    },
    { 
      src: "/assets/11.5UTR.png",
      alt: "UTR 11.5 profile",
      style: {
        objectPosition: "center center",
        objectFit: "contain",
        backgroundColor: "#f5f5f5"
      },
      modalStyle: {
        width: "92vw",
        height: "92vh",
        maxWidth: "none",
        maxHeight: "none",
        objectFit: "contain"
      }
    }
  ];

  return (
    <Fade triggerOnce={true}>
      <section id="coaching" style={{ background: 'white', color: '#333' }}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <div className="title-box">
                <h3 className="title-a" style={{ color: '#333' }}>{coaching.section?.title || "Tennis Coaching"} <div className="line-mf"></div></h3>
                <div className="subtitle-a" style={{ color: '#666' }}>{coaching.section?.description || "Elevate your game with personalized tennis coaching!"}</div>
                <p style={{ marginTop: "0.75rem" }}>
                  <Link to="/" style={{ color: '#2ea44f', fontWeight: 500 }}>
                    ← Return home
                  </Link>
                </p>
              </div>
            </div>
          </div>

          {/* Pricing Models */}
          <div className="row" style={{ marginBottom: "2rem" }}>
            <div className="col-sm-12">
              <h4 className="about-bold" style={{ color: '#333' }}>Pricing Models</h4>
              <div className="row">
                {pricingModels.map((model, idx) => (
                  <div key={idx} className="col-md-6" style={{ marginBottom: "1.5rem" }}>
                    <div className="card-recentprojects" style={{ padding: "1.5rem", minHeight: "180px", background: '#f5f5f5' }}>
                      <h5 style={{ color: '#333', fontWeight: 600 }}>{model.title}</h5>
                      <div style={{ fontSize: "1.3rem", fontWeight: 700, margin: "0.5rem 0" }}>
                        <span style={{ color: '#2ea44f' }}>{model.price}</span>
                      </div>
                      <div style={{ color: '#666' }}>{model.description}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Images Section */}
          <div className="row" style={{ marginBottom: "2rem" }}>
            <div className="col-sm-12">
              <h4 className="about-bold" style={{ color: '#333' }}>Gallery</h4>
              <div style={{ display: "flex", gap: "1.5rem", flexWrap: "wrap", justifyContent: "center" }}>
                {galleryImages.map((image, index) => (
                  <img
                    key={index}
                    src={image.src}
                    alt={image.alt}
                    style={{
                      width: "300px",
                      height: "200px",
                      borderRadius: "8px",
                      cursor: "pointer",
                      transition: "transform 0.2s",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      ...image.style // Apply specific framing for each image
                    }}
                    onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.02)"}
                    onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                    onClick={() => setSelectedImage(image)}
                  />
                ))}
              </div>
            </div>
          </div>

          {/* Rankings, Accolades & Schedule */}
          <div className="row">
            <div className="col-md-4">
              <h4 className="about-bold" style={{ color: '#333' }}>Rankings</h4>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {rankings.map((item, idx) => (
                  <li key={idx} style={{ color: '#666', marginBottom: "0.5rem" }}>
                    <strong style={{ color: '#2ea44f' }}>{item.label}:</strong> {item.value}
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-4">
              <h4 className="about-bold" style={{ color: '#333' }}>Accolades</h4>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {accolades.map((item, idx) => (
                  <li key={idx} style={{ color: '#666', marginBottom: "0.5rem" }}>
                    <strong style={{ color: '#2ea44f' }}>{item.title}:</strong> {item.award}
                  </li>
                ))}
              </ul>
            </div>
            <div className="col-md-4">
              <h4 className="about-bold" style={{ color: '#333' }}>RPI Tennis Schedule</h4>
              <p style={{ color: '#666', marginBottom: "0.5rem" }}>
                View the RPI Men's Tennis team's current performance and schedule:
                <br />
                <a 
                  href={coaching.schedule_link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  style={{
                    color: '#2ea44f',
                    textDecoration: 'none',
                    fontWeight: 500,
                    display: 'inline-block',
                    marginTop: '0.5rem'
                  }}
                >
                  View Schedule →
                </a>
              </p>
            </div>
          </div>
        </div>

        <ImageModal
          src={selectedImage?.src}
          alt={selectedImage?.alt}
          isOpen={selectedImage !== null}
          onClose={() => setSelectedImage(null)}
          imageStyle={selectedImage?.modalStyle}
        />
      </section>
    </Fade>
  );
};

export default Coaching; 